'use client';

import { homeConfig } from '@/features/home/home.config';
import { useLocalePath } from '@/shared/hooks';
import { useT } from 'next-i18next/client';
import Link from 'next/link';
import type { FC } from 'react';

export const HeroBlock: FC = () => {
  const { t } = useT(homeConfig.i18nNamespaces);
  const { to } = useLocalePath();

  return (
    <div className="relative min-h-screen flex flex-col justify-end">
      <div className="container pb-24 relative">
        <p className="text-xs font-medium tracking-widest uppercase text-[#F24E1E] mb-6">
          {t('home:hero.label')}
        </p>
        <h1 className="text-[clamp(40px,6vw,72px)] font-medium tracking-[-0.025em] leading-[1] text-white max-w-3xl">
          {t('home:hero.title')}
        </h1>
        <p className="mt-6 text-base text-white/60 max-w-md leading-6">
          {t('home:hero.description')}
        </p>
        <div className="mt-8 flex items-center gap-6">
          <Link
            href={to('/contact')}
            className="text-sm font-medium text-white hover:text-[#F24E1E] transition-colors duration-300"
          >
            {t('home:hero.cta')} →
          </Link>
          <Link
            href={to('/projects')}
            className="text-sm font-medium text-white/40 hover:text-white/60 transition-colors duration-300"
          >
            {t('home:hero.ctaSecondary')} ↓
          </Link>
        </div>
      </div>
      <div
        className="absolute bottom-8 right-6 text-[10px] tracking-[0.3em] text-white/20 uppercase"
        style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)' }}
        aria-hidden="true"
      >
        scroll
      </div>
    </div>
  );
};
